





























import { Component, Prop, Vue } from 'vue-property-decorator'
import { AppStoreModule as appStore } from '@/shared/config/store/app-store'
import { PermissionStoreModule as permissionStore } from '@/shared/config/store/permission-store'
import { SettingsStoreModule as settingsStore } from '@/shared/config/store/settings-store'
import SidebarItem from './SidebarItem.vue'
import SidebarLogo from './SidebarLogo.vue'
import variables from '@/styles/_variables.scss'

@Component({
  name: 'SideBar',
  components: {
    SidebarItem,
    SidebarLogo
  }
})
export default class extends Vue {
  public routes = permissionStore.routes;

  get sidebar() {
    return appStore.sidebar
  }

  get showLogo() {
    return settingsStore.showSidebarLogo
  }

  get menuActiveTextColor() {
    if (settingsStore.sidebarTextTheme) {
      return settingsStore.theme
    } else {
      return variables.menuActiveText
    }
  }

  get variables() {
    return variables
  }

  get activeMenu() {
    const route = this.$route
    const { meta, path } = route
    // if set path, the sidebar will highlight the path you set
    if (meta.activeMenu) {
      return meta.activeMenu
    }
    return path
  }

  get isCollapse() {
    return !this.sidebar.opened
  }
}
